import React, { Component } from 'react';
import getData from './../../data-services/api';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Loader from '../../components/CustomLoader';
import noResultFoundImage from '../MyFCP/images/noResultFoundImage.png';
import { Paper } from '@material-ui/core';

const queryString = require('query-string');
export default class ViewUploads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            workshops: [],
            userData: {},
        };
    }

    async componentDidMount() {
        const parsed = queryString.parse(window.location.search);
        const ID = parsed.id;
        var SFID = this.props.location.SFID ? this.props.location.SFID : ID;
        Promise.all([
            getData(
                `select name,Account__c,Image_URL__c from salesforce.Uploaded_Content__c where account__c = '${SFID}'`
            ),
        ]).then(([uploadedImageData, ...data]) => {
            this.setState({
                uploadedImageData: uploadedImageData.result,
                loading: false,
            });
        });
    }

    render() {
        const { history } = this.props;
        const { loading, uploadedImageData } = this.state;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                View Uploads
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <Paper style={{ marginTop: 10 }}>
                            {uploadedImageData.length > 0 ? (
                                <div className="viewImage">
                                    {uploadedImageData &&
                                        uploadedImageData.map((item) => {
                                            return (
                                                <>
                                                    <div>
                                                        <img
                                                            src={item.image_url__c}
                                                            className="m-2 viewUpload__Image"
                                                            alt="img"
                                                        />
                                                    </div>
                                                    <hr />
                                                </>
                                            );
                                        })}
                                </div>
                            ) : (
                                <Grid container spacing={8} justify="center" alignItems="center">
                                    <img
                                        style={{
                                            marginTop: '50px',
                                            width: 220,
                                            height: 190,
                                        }}
                                        src={noResultFoundImage}
                                        alt="img"
                                    />
                                </Grid>
                            )}
                        </Paper>
                    </>
                )}
            </>
        );
    }
}
